// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h4 {
  color: #369;
}
#rolesRow {
  color: black;
}

#rolesRow td {
  transition: box-shadow 0.15s ease, background-color 0.15s ease;
}

tr#rolesRow:hover td {
  background-color: #f0f6ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/app/daily-candidate-summary/daily-candidate-summary.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":["h4 {\n  color: #369;\n}\n#rolesRow {\n  color: black;\n}\n\n#rolesRow td {\n  transition: box-shadow 0.15s ease, background-color 0.15s ease;\n}\n\ntr#rolesRow:hover td {\n  background-color: #f0f6ff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  position: relative;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
